import { useContext } from 'react';
import SubSections from '~/constants/subSections';
import Sections from '~/constants/vdp/sections';
import { useIsMobile } from '~/context/common/DeviceContext';
import DiscountContext from '~/context/common/DiscountContext';
import useKeyWithInterval from '~/hooks/common/useKeyWithInterval';
import { usePriceDrop } from '~/hooks/vdp';
import NewPriceIcon from '~/icons/NewPriceIcon';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

type OwnProps = {
  previousPrice: number;
  price: number;
};

export default function PriceDrop({ previousPrice, price }: OwnProps) {
  const { hasDiscount, totalDiscount } = useContext(DiscountContext);
  const { restrictedState } = usePriceDrop();
  const isMobile = useIsMobile();
  const priceKey = useKeyWithInterval();
  const shouldDisplayOriginalPrice = !restrictedState || hasDiscount;

  return (
    <div className="flex items-end gap-x-4">
      <a
        className="flex h-full items-center"
        data-analytics-id="Hero Header - Price Drop"
        data-qa="hero-header-price-drop-arrow"
        href={
          isMobile ? `#${SubSections.NewPrice}` : `#${Sections.AboutThePrice}`
        }
      >
        <NewPriceIcon
          className="pointer-events-auto h-[20px] w-[20px] fill-green-2 hover:fill-green-3"
          isInRestrictedState={restrictedState}
        />
      </a>
      <span key={priceKey} className="text-blue-7 tl-header-m m:tl-header-xl">
        ${formatAndDropDecimal(price - totalDiscount)}
      </span>
      {shouldDisplayOriginalPrice && (
        <span
          className="text-grey-5 tl-body-s m:tl-body-m"
          data-qa="hero-header-old-price"
        >
          was{' '}
          <span className="line-through">
            ${formatAndDropDecimal(hasDiscount ? price : previousPrice)}
          </span>
        </span>
      )}
    </div>
  );
}
